

/* MagFit: wymagana zgoda na e-paragon */
(function () {
  function initEReceiptConsent() {
    var summary = document.getElementById('step-3');
    var submit = document.getElementById('submit-order');
    if (!summary || !submit || document.getElementById('magfit-e-receipt-consent')) return;

    var wrap = document.createElement('div');
    wrap.id = 'magfit-e-receipt-consent';
    wrap.className = 'magfit-e-receipt-consent';
    wrap.innerHTML =
      '<label class="magfit-e-receipt-consent__label">' +
        '<input type="checkbox" id="e-receipt-consent" required aria-describedby="e-receipt-help e-receipt-error">' +
        '<span><strong>Zgoda na e-paragon *</strong><br>' +
        'Wyrażam zgodę na otrzymanie paragonu fiskalnego w postaci elektronicznej na adres e-mail podany w zamówieniu. Potwierdzam, że jest to uzgodniony sposób wydania paragonu.</span>' +
      '</label>' +
      '<p id="e-receipt-help" class="magfit-e-receipt-consent__help">E-paragon zastępuje wersję papierową i zostanie przesłany po zarejestrowaniu płatności. Jeśli potrzebujesz paragonu papierowego, skontaktuj się z nami przed złożeniem zamówienia.</p>' +
      '<p id="e-receipt-error" class="magfit-e-receipt-consent__error" role="alert" hidden>Zaznacz zgodę na e-paragon, aby przejść dalej.</p>';

    var actions = summary.querySelector('.magfit-actions');
    summary.insertBefore(wrap, actions || submit.parentNode);

    var style = document.createElement('style');
    style.textContent =
      '.magfit-e-receipt-consent{margin:22px 0;padding:18px;border:1px solid #d8d1c2;border-radius:14px;background:#fffdf8;color:#1f382c}' +
      '.magfit-e-receipt-consent__label{display:flex;gap:12px;align-items:flex-start;cursor:pointer;line-height:1.5}' +
      '.magfit-e-receipt-consent__label input{width:20px;height:20px;min-width:20px;margin-top:2px;accent-color:#356849}' +
      '.magfit-e-receipt-consent__help{margin:10px 0 0 32px;color:#5d6d64;font-size:13px;line-height:1.5}' +
      '.magfit-e-receipt-consent__error{margin:10px 0 0 32px;color:#9c3f3f;font-size:13px;font-weight:700}';
    document.head.appendChild(style);

    submit.addEventListener('click', function (event) {
      if (submit.dataset.eReceiptConfirmed === 'true') {
        delete submit.dataset.eReceiptConfirmed;
        return;
      }

      var consent = document.getElementById('e-receipt-consent');
      var error = document.getElementById('e-receipt-error');
      if (!consent.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        error.hidden = false;
        consent.focus();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = true;
      submit.disabled = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: {
          'Zgoda na e-paragon': 'Tak — udzielona w zamówieniu online',
          'Sposób dostarczenia e-paragonu': 'Adres e-mail podany w zamówieniu'
        } })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart update failed');
        submit.dataset.eReceiptConfirmed = 'true';
        submit.disabled = false;
        submit.click();
      }).catch(function () {
        submit.disabled = false;
        error.textContent = 'Nie udało się zapisać zgody. Spróbuj ponownie.';
        error.hidden = false;
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEReceiptConsent);
  } else {
    initEReceiptConsent();
  }
})();
/* MagFit v7. Checkout remains gated until product and end-to-end validation. */
(function (global, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!global || !global.document) return;
  global.MagFitOrderUtils = Object.freeze(api);
  function boot() { api.init(global.document, global.MAGFIT_CONFIG || {}, global); }
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', boot);
  else boot();
  global.document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
  var MONTHS = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'];
  function pad(value) { return String(value).padStart(2, '0'); }
  function dateKey(date) { return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()); }
  function parseDate(key) {
    if (typeof key !== 'string' || !DATE_PATTERN.test(key)) return null;
    var date = new Date(key + 'T12:00:00Z');
    return Number.isFinite(date.getTime()) && dateKey(date) === key ? date : null;
  }
  function shiftDate(key, count) {
    var date = parseDate(key);
    if (!date || !Number.isInteger(count)) throw new Error('Invalid calendar date');
    date.setUTCDate(date.getUTCDate() + count);
    return dateKey(date);
  }
  function localClock(now, timeZone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone || 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return { date: values.year + '-' + values.month + '-' + values.day, hour: Number(values.hour) };
  }
  function isWeekday(key) {
    var date = parseDate(key);
    return !!date && date.getUTCDay() !== 0 && date.getUTCDay() !== 6;
  }
  function earliestAllowedDate(now, config) {
    config = config || {};
    var clock = localClock(now, config.timeZone);
    // Cutoff includes the entire last minute of the local day; midnight starts a new day.
    var candidate = shiftDate(clock.date, 2);
    while (!isWeekday(candidate)) candidate = shiftDate(candidate, 1);
    return candidate;
  }
  function calendarBounds(now, config) {
    var clock = localClock(now, config && config.timeZone);
    var first = clock.date.slice(0, 7) + '-01';
    var end = parseDate(first);
    end.setUTCMonth(end.getUTCMonth() + 2, 0);
    return { first: first, last: '9999-12-31', earliest: earliestAllowedDate(now, config) };
  }
  function isEligibleDate(key, bounds) {
    return isWeekday(key) && key >= bounds.earliest && key <= bounds.last;
  }
  function minimumDays(config) {
    return Math.max(5, Number.isInteger(config.minimumDays) ? config.minimumDays : 5);
  }
  function initialBusinessDays(start, count, bounds) {
    if (!isEligibleDate(start, bounds) || !Number.isInteger(count) || count < 1) return [];
    var days = [];
    for (var key = start; key <= bounds.last && days.length < count; key = shiftDate(key, 1)) {
      if (isEligibleDate(key, bounds)) days.push(key);
    }
    return days.length === count ? days : [];
  }
  function normalizeName(value) {
    return String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('pl-PL');
  }
  function normalizePostcode(value) {
    var code = String(value || '').trim().replace(/\s/g, '');
    return /^\d{5}$/.test(code) ? code.slice(0, 2) + '-' + code.slice(2) : code;
  }
  function validateDelivery(delivery, city, postcode) {
    var code = normalizePostcode(postcode);
    if (!/^\d{2}-\d{3}$/.test(code)) return { valid: false, reason: 'invalid-postcode' };
    var locations = delivery && Array.isArray(delivery.locations) ? delivery.locations : [];
    var location = locations.find(function (item) { return normalizeName(item.name) === normalizeName(city); });
    if (!location) return { valid: false, reason: 'unknown-city' };
    var postcodes = Array.isArray(location.postcodes) ? location.postcodes : [];
    // An empty list explicitly means that postcode coverage has not been verified.
    if (!postcodes.length) return { valid: true, location: location.name, postcode: code, postcodeVerified: false };
    var matches = postcodes.some(function (item) {
      return normalizePostcode(item) === code;
    });
    if (!matches) return { valid: false, reason: 'postcode-mismatch' };
    return { valid: true, location: location.name, postcode: code, postcodeVerified: true };
  }
  function validNip(value) {
    var nip = String(value || '').replace(/[\s-]/g, '');
    if (!/^\d{10}$/.test(nip) || /^(\d)\1{9}$/.test(nip)) return false;
    var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    var sum = weights.reduce(function (total, weight, index) { return total + weight * Number(nip[index]); }, 0);
    return sum % 11 === Number(nip[9]);
  }
  function validPhone(value) {
    var phone = String(value || '').trim();
    return /^\+?[\d\s().-]+$/.test(phone) && /^\d{9,15}$/.test(phone.replace(/\D/g, ''));
  }
  function validateContact(fields, config) {
    var errors = {};
    ['imie', 'nazwisko', 'ulica', 'nr-bud'].forEach(function (name) {
      if (!String(fields[name] || '').trim()) errors['f-' + name] = 'Uzupełnij to pole.';
    });
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(fields.email || '').trim())) errors['f-email'] = 'Wpisz poprawny adres e-mail.';
    if (!validPhone(fields.telefon)) errors['f-telefon'] = 'Wpisz numer telefonu zawierający od 9 do 15 cyfr.';
    var delivery = validateDelivery(config.delivery, fields.miasto, fields.kod);
    if (!delivery.valid) {
      if (delivery.reason === 'unknown-city') errors['f-miasto'] = 'Wybierz miejscowość z listy dostaw.';
      else errors['f-kod'] = delivery.reason === 'invalid-postcode'
        ? 'Wpisz kod pocztowy w formacie 00-000.'
        : 'Ten kod nie odpowiada wybranej miejscowości na roboczej liście dostaw.';
    }
    if (!fields['brak-dom'] && !String(fields.domofon || '').trim()) errors['f-domofon'] = 'Podaj kod domofonu lub zaznacz, że go nie posiadasz.';
    if (fields.faktura) {
      if (!validNip(fields.nip)) errors['f-nip'] = 'Wpisz poprawny, dziesięciocyfrowy NIP.';
      if (!String(fields.firma || '').trim()) errors['f-firma'] = 'Podaj nazwę firmy.';
    }
    if (!fields.regulamin) errors['f-regulamin'] = 'Zaznacz akceptację regulaminu, aby przejść do płatności.';
    return errors;
  }
  function resolveDiscount(config, input) {
    var code = String(input || '').trim().toUpperCase();
    if (!code) return { valid: true, code: '', percent: 0, label: '' };
    var codes = config.discountCodes || {};
    var item = Object.prototype.hasOwnProperty.call(codes, code) ? codes[code] : null;
    if (!item || !Number.isFinite(item.percent) || item.percent <= 0 || item.percent > 100) return { valid: false, code: code };
    return { valid: true, code: code, percent: item.percent, label: String(item.label || code) };
  }
  function calculateQuote(config, selection) {
    var kcal = (config.kcalOptions || []).find(function (option) { return option.kcal === Number(selection.kcal); });
    var meals = (config.mealOptions || []).find(function (option) { return option.count === Number(selection.meals); });
    var rate = config.prices && config.prices[selection.diet] && config.prices[selection.diet][(config.kcalOptions || []).indexOf(kcal)];
    if (!kcal || !meals || !Number.isFinite(rate) || rate <= 0) throw new Error('Wybierz dostępną kaloryczność i liczbę posiłków.');
    var dates = Array.from(new Set(selection.days || []));
    if (!dates.length || dates.some(function (key) { return !parseDate(key); })) throw new Error('Wybierz dni dostawy.');
    var discount = resolveDiscount(config, selection.discountCode);
    if (!discount.valid) throw new Error('Nieprawidłowy kod symulacyjny.');
    var cost = config.delivery && config.delivery.cost;
    if (!Number.isFinite(cost) || cost < 0) throw new Error('Brakuje poprawnej roboczej stawki dostawy.');
    // Round each day's PLN price once, then perform all arithmetic in grosze.
    var perDay = Math.round(rate * 100);
    var subtotal = perDay * dates.length;
    var reduction = Math.round(subtotal * discount.percent / 100);
    var delivery = Math.round(cost * 100);
    return {
      dayCount: dates.length, perDay: perDay, subtotal: subtotal, discount: reduction,
      delivery: delivery, total: subtotal - reduction + delivery, discountCode: discount.code,
      provisional: true
    };
  }
  function validateSelection(config, selection, now) {
    if (!(config.products || []).some(function (product) { return product.id === selection.diet && product.available !== false; })) return 'Wybierz dietę.';
    if (!(config.kcalOptions || []).some(function (option) { return option.kcal === Number(selection.kcal); })) return 'Wybierz kaloryczność.';
    if (!(config.mealOptions || []).some(function (option) { return option.count === Number(selection.meals); })) return 'Wybierz liczbę posiłków.';
    var days = Array.from(new Set(selection.days || []));
    if (days.length < minimumDays(config)) return 'Wybierz co najmniej ' + minimumDays(config) + ' dni od poniedziałku do piątku.';
    var bounds = calendarBounds(now, config);
    if (days.some(function (key) { return !isEligibleDate(key, bounds); })) return 'Wybrane daty nie są już dostępne. Sprawdź kalendarz i wybierz przyszłe dni od poniedziałku do piątku.';
    try { calculateQuote(config, selection); } catch (error) { return error.message; }
    return '';
  }
  function paymentState(config) {
    // No payment adapter exists in this draft, including when the demo flag changes.
    if (config.demoMode === true) return { enabled: false, reason: 'simulation' };
    var variants = Array.isArray(config.products) && config.products.length > 0 && config.products.every(function (product) {
      return Number.isSafeInteger(Number(product.variantId)) && Number(product.variantId) > 0;
    });
    return { enabled: false, reason: variants ? 'checkout-not-connected' : 'missing-variants' };
  }
  function formatMoney(cents) {
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(cents / 100);
  }

  function init(document, config, browser) {
    var root = document.getElementById('magfit-konfigurator');
    if (!root || root.dataset.magfitReady === 'true') return null;
    root.dataset.magfitReady = 'true';
    function byId(id) { var element = document.getElementById(id); return element && root.contains(element) ? element : null; }
    function text(id, value) { var element = byId(id); if (element) element.textContent = value; }
    function visible(element, show) { if (element) { element.hidden = !show; element.style.display = show ? '' : 'none'; } }
    function el(tag, className, content) {
      var element = document.createElement(tag);
      if (className) element.className = className;
      if (content !== undefined) element.textContent = content;
      return element;
    }
    function button(className, content) { var element = el('button', className, content); element.type = 'button'; return element; }
    function listen(id, event, handler) { var element = byId(id); if (element) element.addEventListener(event, handler); }
    var now = function () { return new Date(); };
    var monthOffset = 0;
    var state = { step: 1, diet: '', kcal: null, meals: null, days: [], discountCode: '' };
    try {
      var requested = new URLSearchParams(browser.location.search).get('dieta');
      if ((config.products || []).some(function (product) { return product.id === requested && product.available !== false; })) state.diet = requested;
    } catch (error) { /* A missing location must not stop the form. */ }
    var fiveMeals = (config.mealOptions || []).find(function (option) { return option.count === 5; });
    if (fiveMeals) state.meals = fiveMeals.count;
    var feedback = byId('discount-feedback') || byId('discount-status');
    if (!feedback && byId('f-rabat')) {
      feedback = el('p', 'magfit-hint'); feedback.id = 'discount-feedback';
      byId('f-rabat').parentElement.appendChild(feedback);
    }
    [feedback, byId('delivery-status'), byId('order-error'), byId('order-success')].forEach(function (element) {
      if (element) { element.setAttribute('role', 'status'); element.setAttribute('aria-live', 'polite'); }
    });
    var removeCode = byId('remove-discount');
    if (!removeCode && byId('apply-discount')) {
      removeCode = button('magfit-btn magfit-btn--secondary', 'Usuń kod'); removeCode.id = 'remove-discount';
      byId('apply-discount').insertAdjacentElement('afterend', removeCode);
    }
    visible(removeCode, false);
    root.querySelectorAll('button').forEach(function (element) { element.type = 'button'; });
    root.addEventListener('submit', function (event) { event.preventDefault(); });
    var enclosingForm = root.closest('form');
    if (enclosingForm) enclosingForm.addEventListener('submit', function (event) { event.preventDefault(); });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
        event.preventDefault();
        if (event.target.id === 'f-rabat') applyDiscount();
      }
    });

    function clearNotice() { visible(byId('order-error'), false); visible(byId('order-success'), false); }
    function showNotice(id, message) { text(id, message); visible(byId(id), true); }
    function clearFieldError(field) {
      if (!field) return;
      field.removeAttribute('aria-invalid');
      var errorId = field.id + '-magfit-error';
      var error = byId(errorId); if (error) error.remove();
      var otherDescriptions = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) { return id && id !== errorId; });
      if (otherDescriptions.length) field.setAttribute('aria-describedby', otherDescriptions.join(' '));
      else field.removeAttribute('aria-describedby');
    }
    function fieldError(field, message) {
      if (!field) return;
      clearFieldError(field);
      var error = el('p', 'magfit-field-error', message); error.id = field.id + '-magfit-error';
      error.style.color = '#a12622'; error.style.fontSize = '14px'; error.style.margin = '6px 0 0';
      (field.closest('.magfit-field') || field.parentElement).appendChild(error);
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', ((field.getAttribute('aria-describedby') || '') + ' ' + error.id).trim());
    }
    root.querySelectorAll('input, select, textarea').forEach(function (field) {
      var wrapper = field.closest('.magfit-field');
      var label = wrapper && wrapper.querySelector('label');
      if (label && field.id && field.type !== 'checkbox' && !label.contains(field)) label.htmlFor = field.id;
      field.addEventListener('input', function () { clearFieldError(field); clearNotice(); });
      field.addEventListener('change', function () { clearFieldError(field); clearNotice(); });
    });

    function choiceGroup(id, label, choices, selected, onChoose, renderContent) {
      var container = byId(id); if (!container) return;
      container.replaceChildren(); container.setAttribute('role', 'radiogroup'); container.setAttribute('aria-label', label);
      var checkedIndex = choices.findIndex(function (choice) { return choice.value === selected; });
      choices.forEach(function (choice, index) {
        var item = button(id === 'diet-cards' ? 'magfit-diet-card' : 'magfit-tile');
        var checked = choice.value === selected;
        item.classList.toggle('selected', checked); item.classList.toggle('active', checked);
        item.setAttribute('role', 'radio'); item.setAttribute('aria-checked', String(checked));
        item.tabIndex = index === (checkedIndex < 0 ? 0 : checkedIndex) ? 0 : -1;
        item.dataset.value = String(choice.value); renderContent(item, choice);
        function choose() {
          if (choice.product && choice.product.available === false) return;
          onChoose(choice.value); clearNotice(); renderChoices(); updateSummary();
          var target = Array.from(container.querySelectorAll('button')).find(function (candidate) { return candidate.dataset.value === String(choice.value); });
          if (target) target.focus({ preventScroll: true });
        }
        item.addEventListener('click', choose);
        item.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % choices.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + choices.length - 1) % choices.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = choices.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            var buttons=container.querySelectorAll('button');
            var direction=(event.key==='ArrowLeft'||event.key==='ArrowUp'||event.key==='End')?-1:1;
            for(var tries=0;tries<choices.length && buttons[next].disabled;tries++) next=(next+direction+choices.length)%choices.length;
            if(!buttons[next].disabled) buttons[next].click();
          }
        });
        container.appendChild(item);
      });
    }
    function renderChoices() {
      choiceGroup('diet-cards', 'Dieta', (config.products || []).map(function (product) { return { value: product.id, product: product }; }), state.diet, function (value) { state.diet = value; }, function (item, choice) {
        var product = choice.product;
        if(product.available === false){ item.disabled=true; item.setAttribute('aria-disabled','true'); item.tabIndex=-1; item.style.opacity='0.55'; item.style.cursor='not-allowed'; }
        var source = config.images && config.images[product.id];
        if (source) { var image = el('img', 'magfit-diet-card__image'); image.src = source; image.alt = ''; image.loading = 'lazy'; item.appendChild(image); }
        item.appendChild(el('span', 'magfit-diet-card__name', (product.emoji ? product.emoji + ' ' : '') + product.name));
        if (product.description) item.appendChild(el('span', 'magfit-diet-card__description', product.description));
        item.appendChild(el('span', 'magfit-diet-card__selected', product.available === false ? 'WKRÓTCE — Pełna oferta już wkrótce' : product.id === state.diet ? 'Wybrano' : 'Wybierz'));
      });
      choiceGroup('kcal-tiles', 'Kaloryczność', (config.kcalOptions || []).map(function (option) { return { value: option.kcal }; }), state.kcal, function (value) { state.kcal = value; }, function (item, choice) { item.textContent = choice.value + ' kcal'; });
      choiceGroup('meal-tiles', 'Liczba posiłków dziennie', (config.mealOptions || []).map(function (option) { return { value: option.count }; }), state.meals, function (value) { state.meals = value; }, function (item, choice) { item.textContent = choice.value + (choice.value === 5 ? ' posiłków' : ' posiłki'); });
    }
    function renderCalendar(focusDate) {
      var calendars = byId('calendars'); if (!calendars) return;
      calendars.replaceChildren();
      var bounds = calendarBounds(now(), config);
      var removedDates = state.days.some(function (key) { return !isEligibleDate(key, bounds); });
      state.days = state.days.filter(function (key) { return isEligibleDate(key, bounds); });
      var first = parseDate(bounds.first); first.setUTCMonth(first.getUTCMonth()+monthOffset);
      var nav=el('div','magfit-calendar-nav');
      var prev=button('magfit-btn magfit-btn--secondary','← Poprzednie miesiące'), next=button('magfit-btn magfit-btn--secondary','Kolejne miesiące →');
      prev.disabled=monthOffset===0;
      prev.addEventListener('click',function(){monthOffset=Math.max(0,monthOffset-2);renderCalendar();});
      next.addEventListener('click',function(){monthOffset+=2;renderCalendar();});
      nav.appendChild(prev);nav.appendChild(next);calendars.appendChild(nav);
      for (var offset = 0; offset < 2; offset++) {
        var month = new Date(first.getTime()); month.setUTCMonth(month.getUTCMonth() + offset);
        var section = el('section', 'magfit-calendar magfit-cal');
        var heading = el('h3', 'magfit-cal-header magfit-cal__header magfit-cal__title', MONTHS[month.getUTCMonth()] + ' ' + month.getUTCFullYear());
        heading.id = 'magfit-month-' + offset; section.setAttribute('aria-labelledby', heading.id); section.appendChild(heading);
        var grid = el('div', 'magfit-cal-grid magfit-cal__grid');
        grid.style.display = 'grid'; grid.style.gridTemplateColumns = 'repeat(7, minmax(0, 1fr))'; grid.style.gap = '4px';
        ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'].forEach(function (label) { grid.appendChild(el('span', 'magfit-cal-weekday magfit-cal__weekday', label)); });
        var leading = (month.getUTCDay() + 6) % 7;
        for (var blank = 0; blank < leading; blank++) { var spacer = el('span'); spacer.setAttribute('aria-hidden', 'true'); grid.appendChild(spacer); }
        var monthEnd = new Date(month.getTime()); monthEnd.setUTCMonth(monthEnd.getUTCMonth() + 1, 0);
        for (var number = 1; number <= monthEnd.getUTCDate(); number++) {
          var key = month.getUTCFullYear() + '-' + pad(month.getUTCMonth() + 1) + '-' + pad(number);
          var day = button('magfit-cal__day magfit-cal-day magfit-day', String(number)); day.dataset.date = key;
          var chosen = state.days.indexOf(key) !== -1;
          day.classList.toggle('selected', chosen); day.classList.toggle('active', chosen);
          var fullLabel = new Intl.DateTimeFormat('pl-PL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(parseDate(key));
          day.setAttribute('aria-label', fullLabel); day.setAttribute('aria-pressed', String(chosen));
          day.disabled = !isEligibleDate(key, bounds) || (!state.days.length && !initialBusinessDays(key, minimumDays(config), bounds).length);
          day.addEventListener('click', function (event) {
            var selectedDate = event.currentTarget.dataset.date;
            var currentBounds = calendarBounds(now(), config);
            if (!isEligibleDate(selectedDate, currentBounds)) { renderCalendar(); updateSummary(); return; }
            if (!state.days.length) state.days = initialBusinessDays(selectedDate, minimumDays(config), currentBounds);
            else if (state.days.indexOf(selectedDate) !== -1) state.days = state.days.filter(function (value) { return value !== selectedDate; });
            else state.days.push(selectedDate);
            state.days.sort(); clearNotice(); renderCalendar(selectedDate); updateSummary();
          });
          grid.appendChild(day);
        }
        section.appendChild(grid); calendars.appendChild(section);
      }
      text('calendar-notice', (removedDates ? 'Usunięto daty, które nie są już dostępne. ' : '') + 'Zamów dziś do 23:59, a pierwszą torbę możesz otrzymać już jutro wieczorem — na kolejny dzień diety. Diety realizujemy pon.–pt.; termin zależy od daty wybranej w kalendarzu. Najbliższa dostawa: ' + shiftDate(bounds.earliest, -1) + ' wieczorem. Pierwszy dzień diety: ' + bounds.earliest + '.');
      if (focusDate) {
        var focusTarget = Array.from(calendars.querySelectorAll('button')).find(function (item) { return item.dataset.date === focusDate; });
        if (focusTarget && !focusTarget.disabled) focusTarget.focus({ preventScroll: true });
      }
    }
    function getQuote() { try { return calculateQuote(config, state); } catch (error) { return null; } }
    function updateSummary() {
      var product = (config.products || []).find(function (item) { return item.id === state.diet; });
      var quote = getQuote();
      text('s-dieta', product ? product.name : '—'); text('s-kcal', state.kcal ? state.kcal + ' kcal' : '—');
      text('s-posilki', state.meals ? String(state.meals) : '—'); text('s-dni', String(state.days.length));
      text('day-count-label', 'Wybrano ' + state.days.length + ' dni roboczych');
      visible(byId('day-counter'), state.days.length > 0);
      text('price-label', quote ? 'Łączna kwota: ' + formatMoney(quote.total) : 'Łączna kwota: —');
      text('s-cena-dzien', quote ? formatMoney(quote.perDay) : '—');
      text('s-subtotal', quote ? formatMoney(quote.subtotal) : '—');
      var discountRow = byId('s-discount');
      text('s-discount', quote && quote.discount > 0 ? '−' + formatMoney(quote.discount) : '');
      if (discountRow) visible(discountRow.closest('.magfit-srow'), !!(quote && quote.discount > 0));
      text('s-delivery', quote ? formatMoney(quote.delivery) : '—');
      text('s-total', quote ? formatMoney(quote.total) : '—');
      var error = validateSelection(config, state, now());
      text('s-hint', error || 'Cena zależy od diety i kaloryczności. Liczba posiłków nie zmienia ceny.');
      if (byId('step1-next')) byId('step1-next').disabled = !!error;
      if (state.step === 3) renderReview();
    }
    function fields() {
      var values = {};
      ['imie', 'nazwisko', 'email', 'telefon', 'kod', 'miasto', 'ulica', 'nr-bud', 'nr-lok', 'domofon', 'brak-dom', 'klatka', 'pietro', 'godziny', 'uwagi', 'faktura', 'nip', 'firma', 'regulamin', 'marketing'].forEach(function (name) {
        var field = byId('f-' + name);
        values[name] = field ? (field.type === 'checkbox' ? field.checked : field.value.trim()) : '';
      });
      return values;
    }
    function deliveryStatus() {
      var address = fields(); var check = validateDelivery(config.delivery, address.miasto, address.kod);
      var target = byId('delivery-status'); if (!target) return;
      if (!address.miasto || !address.kod) target.textContent = 'Wybierz miejscowość i podaj kod pocztowy.';
      else if (check.valid) target.textContent = 'Dostawa dostępna w wybranej miejscowości. Posiłki dostarczamy wieczorem w dniu poprzedzającym dzień diety.';
      else target.textContent = check.reason === 'invalid-postcode' ? 'Wpisz poprawny kod w formacie 00-000.' : 'Kod i miejscowość nie pasują do roboczej listy dostaw. Wybierz zgodną parę z obsługiwanego obszaru.';
    }
    function contactValid() {
      var errors = validateContact(fields(), config);
      root.querySelectorAll('[aria-invalid="true"]').forEach(clearFieldError);
      Object.keys(errors).forEach(function (id) { fieldError(byId(id), errors[id]); });
      deliveryStatus();
      var first = Object.keys(errors)[0];
      if (first && byId(first)) byId(first).focus();
      return !first;
    }
    function details(container, entries) {
      if (!container) return;
      container.replaceChildren(); var list = el('dl');
      entries.forEach(function (entry) { var row = el('div', 'magfit-summary-line'); row.appendChild(el('dt', '', entry[0])); row.appendChild(el('dd', '', entry[1])); list.appendChild(row); });
      container.appendChild(list);
    }
    function renderReview() {
      var quote = getQuote(); var address = fields();
      var product = (config.products || []).find(function (item) { return item.id === state.diet; });
      if (quote && product) {
        var summaryEntries = [
          ['Dieta', product.name], ['Kaloryczność', state.kcal + ' kcal'], ['Posiłki dziennie', String(state.meals)],
          ['Daty dostawy', state.days.join(', ')], ['Cena za dzień', formatMoney(quote.perDay)],
          ['Posiłki łącznie', formatMoney(quote.subtotal)]
        ];
        if (quote.discount > 0) summaryEntries.push(['Rabat', '−' + formatMoney(quote.discount)]);
        summaryEntries.push(['Dostawa', formatMoney(quote.delivery)], ['Łącznie', formatMoney(quote.total)]);
        details(byId('order-summary-detail'), summaryEntries);
      }
      details(byId('address-summary-detail'), [
        ['Odbiorca', address.imie + ' ' + address.nazwisko], ['Kontakt', address.email + ', ' + address.telefon],
        ['Adres', address.ulica + ' ' + address['nr-bud'] + (address['nr-lok'] ? '/' + address['nr-lok'] : '') + ', ' + normalizePostcode(address.kod) + ' ' + address.miasto],
        ['Okno dostawy', config.delivery ? config.delivery.window : '—'],
        ['Domofon', address['brak-dom'] ? 'Brak kodu/domofonu' : address.domofon],
        ['Uwagi', address.uwagi || 'Brak'], ['Faktura', address.faktura ? address.firma + ', NIP ' + address.nip : 'Nie']
      ]);
    }
    function setStep(step) {
      state.step = step; clearNotice();
      for (var number = 1; number <= 3; number++) {
        visible(byId('step-' + number), step === number);
        var indicator = byId('si-' + number);
        if (indicator) { indicator.classList.toggle('active', number === step); indicator.classList.toggle('completed', number < step); if (number === step) indicator.setAttribute('aria-current', 'step'); else indicator.removeAttribute('aria-current'); }
      }
      if (step === 1) renderCalendar();
      if (step === 3) renderReview();
      updateSummary();
      var panel = byId('step-' + step); var heading = panel && panel.querySelector('h2');
      if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
      if (panel) panel.scrollIntoView({ behavior: browser.matchMedia && browser.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    function applyDiscount() {
      var input = byId('f-rabat'); if (!input) return;
      var discount = resolveDiscount(config, input.value);
      clearNotice(); state.discountCode = discount.valid ? discount.code : '';
      visible(removeCode, !!state.discountCode);
      if (feedback) feedback.textContent = !discount.valid ? 'Nie rozpoznano kodu. Rabat nie jest uwzględniony.'
        : discount.code ? 'Kod ' + discount.code + ': ' + discount.percent + '% wyłącznie w symulacji. Nie przyznaje rzeczywistej zniżki.' : 'Kod usunięty. Symulacja nie uwzględnia rabatu.';
      updateSummary();
    }
    listen('apply-discount', 'click', applyDiscount);
    listen('remove-discount', 'click', function () { if (byId('f-rabat')) byId('f-rabat').value = ''; applyDiscount(); });
    listen('f-rabat', 'input', function () {
      state.discountCode = ''; visible(removeCode, false);
      if (feedback) feedback.textContent = byId('f-rabat').value.trim() ? 'Kliknij „Zastosuj”, aby sprawdzić kod w symulacji.' : 'Brak kodu rabatowego.';
      updateSummary();
    });
    listen('step1-next', 'click', function () {
      var error = validateSelection(config, state, now());
      if (error) { renderCalendar(); updateSummary(); text('s-hint', error); return; }
      setStep(2);
    });
    listen('step2-back', 'click', function () { setStep(1); });
    listen('step2-next', 'click', function () { if (contactValid()) setStep(3); });
    listen('step3-back', 'click', function () { setStep(2); });
    text('submit-order', 'Przejdź do płatności');
    listen('submit-order', 'click', function () {
      clearNotice();
      var selectionError = validateSelection(config, state, now());
      if (selectionError) { setStep(1); text('s-hint', selectionError); return; }
      if (Object.keys(validateContact(fields(), config)).length) { setStep(2); contactValid(); return; }
      renderReview();
      var quote = getQuote();
      var handles = { balance: 'balance', sport: 'sport', lowcarb: 'low-carb', sibo: 'sibo-low-fodmap' };
      var handle = handles[state.diet];
      if (!handle || !quote || state.discountCode) {
        showNotice('order-error', 'Nie można teraz przejść do płatności dla tej konfiguracji. Skontaktuj się z nami.');
        return;
      }
      var submit = byId('submit-order');
      if (submit) submit.disabled = true;
      browser.fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Koszyk jest niedostępny.'); return response.json(); })
        .then(function (cart) {
          if (cart.items && cart.items.length) throw new Error('W koszyku są już produkty. Dokończ poprzednie zamówienie lub opróżnij koszyk przed ponowną próbą.');
          return browser.fetch('/products/' + handle + '.js', { credentials: 'same-origin' });
        })
        .then(function (response) { if (!response.ok) throw new Error('Nie udało się sprawdzić produktu.'); return response.json(); })
        .then(function (product) {
          var variant = (product.variants || []).find(function (item) { return String(item.option1) === String(state.kcal); });
          if (!variant || !variant.available || Number(variant.price) !== quote.perDay) throw new Error('Cena lub dostępność wybranego wariantu wymaga potwierdzenia. Spróbuj innej konfiguracji.');
          var d = fields();
          var props = { 'Daty dostawy': state.days.join(', '), 'Posiłki dziennie': String(state.meals), 'Odbiorca': d.imie + ' ' + d.nazwisko, 'Adres dostawy': d.ulica + ' ' + d['nr-bud'] + (d['nr-lok'] ? '/' + d['nr-lok'] : '') + ', ' + d.kod + ' ' + d.miasto, 'Telefon do dostawy': d.telefon, 'Uwagi do dostawy': d.uwagi || '' };
          var encoded = btoa(unescape(encodeURIComponent(JSON.stringify(props)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
          var params = new URLSearchParams();
          params.set('properties', encoded);
          params.set('checkout[email]', d.email);
          params.set('checkout[shipping_address][first_name]', d.imie);
          params.set('checkout[shipping_address][last_name]', d.nazwisko);
          params.set('checkout[shipping_address][address1]', d.ulica + ' ' + d['nr-bud']);
          if (d['nr-lok']) params.set('checkout[shipping_address][address2]', d['nr-lok']);
          params.set('checkout[shipping_address][city]', d.miasto);
          params.set('checkout[shipping_address][zip]', d.kod);
          params.set('checkout[shipping_address][country]', 'PL');
          params.set('checkout[shipping_address][phone]', d.telefon);
          var capacityPart = config.capacity && Number(config.capacity.variantId) > 0 ? ',' + config.capacity.variantId + ':1' : ''; browser.location.assign('/cart/' + variant.id + ':' + state.days.length + capacityPart + '?' + params.toString());
        })
        .catch(function (error) { showNotice('order-error', error.message || 'Nie udało się przejść do płatności.'); if (submit) submit.disabled = false; });
    });
    var city = byId('f-miasto');
    if (city && city.tagName === 'SELECT') {
      var previousCity = city.value; city.replaceChildren();
      var empty = el('option', '', 'Wybierz miejscowość'); empty.value = ''; city.appendChild(empty);
      ((config.delivery && config.delivery.locations) || []).forEach(function (location) { var option = el('option', '', location.name); option.value = location.name; city.appendChild(option); });
      if (Array.from(city.options).some(function (option) { return option.value === previousCity; })) city.value = previousCity;
    }
    var windowSelect = byId('f-godziny');
    if (windowSelect && windowSelect.tagName === 'SELECT') {
      windowSelect.replaceChildren(); var windowOption = el('option', '', config.delivery ? config.delivery.window + ' (roboczo)' : 'Do potwierdzenia');
      windowOption.value = config.delivery ? config.delivery.window : ''; windowSelect.appendChild(windowOption);
    }
    listen('f-miasto', 'change', function () { clearFieldError(byId('f-kod')); deliveryStatus(); });
    if(byId('f-kod')) byId('f-kod').setAttribute('inputmode','numeric');
    listen('f-kod', 'input', function(){var input=byId('f-kod'),digits=input.value.replace(/\D/g,'').slice(0,5);input.value=digits.length>2?digits.slice(0,2)+'-'+digits.slice(2):digits;deliveryStatus();});
    listen('f-kod', 'blur', function () { byId('f-kod').value = normalizePostcode(byId('f-kod').value); deliveryStatus(); });
    function toggleInvoice() {
      var enabled = byId('f-faktura') && byId('f-faktura').checked;
      visible(byId('faktura-fields'), enabled);
      ['f-nip', 'f-firma'].forEach(function (id) { var field = byId(id); if (field) { field.disabled = !enabled; if (!enabled) clearFieldError(field); } });
    }
    function toggleIntercom() {
      var field = byId('f-domofon');
      if (field) { field.disabled = !!(byId('f-brak-dom') && byId('f-brak-dom').checked); if (field.disabled) clearFieldError(field); }
    }
    listen('f-faktura', 'change', toggleInvoice); listen('f-brak-dom', 'change', toggleIntercom);
    renderChoices(); renderCalendar(); toggleInvoice(); toggleIntercom(); deliveryStatus(); updateSummary();
    return { review: function () { if (byId('submit-order')) byId('submit-order').click(); } };
  }
  return {
    parseDate: parseDate, shiftDate: shiftDate, localClock: localClock, isWeekday: isWeekday,
    earliestAllowedDate: earliestAllowedDate, calendarBounds: calendarBounds, isEligibleDate: isEligibleDate,
    initialBusinessDays: initialBusinessDays, normalizePostcode: normalizePostcode, validateDelivery: validateDelivery,
    validNip: validNip, validPhone: validPhone, validateContact: validateContact, resolveDiscount: resolveDiscount,
    calculateQuote: calculateQuote, validateSelection: validateSelection, paymentState: paymentState, init: init
  };
});
